<template>
  <div class="coupon-list-page">
    <a-card :bordered="false" title="优惠券列表" class="coupon-list-card">
      <StandardSearchPageView
        ref="tableWrap"
        rowKey="couponCode"
        :columns="columns"
        :queryParams="queryParams"
        :searchOptions="searchOptions"
        :request-promise="loadList"
        :page-size="10"
      >
        <template v-slot:operation>
          <a-button type="primary" icon="plus" @click="handleCreate">新建优惠券</a-button>
          <a-button type="primary" icon="plus" @click="handleBatchDispatch">批量派券</a-button>
        </template>

        <template v-slot:faceAmount="{ record }">
          <span v-if="record.couponType === 2">{{ record.discountRate }} 折</span>
          <span v-else>¥ {{ record.couponAmt }}</span>
        </template>

        <template v-slot:categoryTypeList="{ record }">
          <a-tooltip :title="getCategoryText(record)">
            <div class="ellipsis-cell">{{ getCategoryText(record) }}</div>
          </a-tooltip>
        </template>

        <template v-slot:action="{ record }">
          <template v-if="Number(record.status) === 0">
            <a @click="handleAdvanceStart(record)">提前开始</a>
            <a-divider type="vertical" />
          </template>
          <template v-else-if="Number(record.status) === 1">
            <a @click="handleAdvanceEnd(record)">提前结束</a>
            <a-divider type="vertical" />
          </template>
          <a @click="handleView(record)">查看详情</a>
          <a-divider type="vertical" />
          <a @click="handleRecord(record)">派券记录</a>
        </template>
      </StandardSearchPageView>
    </a-card>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import { COUPON_STATUS, DISTRIBUTE_WAY, toSelectOptions } from './constants/couponConstants'

export default {
  name: 'CouponList',
  components: {
    StandardSearchPageView
  },
  data () {
    return {
      queryParams: {},
      searchOptions: [
        { name: '优惠券ID', key: 'couponCode', type: 'input', placeholder: '请输入' },
        {
          name: '派券方式',
          key: 'distributeWay',
          type: 'select',
          placeholder: '请选择',
          selectOptions: toSelectOptions(DISTRIBUTE_WAY)
        },
        {
          name: '状态',
          key: 'status',
          type: 'select',
          selectOptions: toSelectOptions(COUPON_STATUS)
        }
      ],
      columns: [
        { title: 'ID', dataIndex: 'couponCode', width: 200 },
        { title: '优惠券标题', dataIndex: 'couponName', width: 180 },
        { title: '券类型', dataIndex: 'couponTypeStr', width: 100 },
        { title: '面额', dataIndex: 'couponAmt', scopedSlots: { customRender: 'faceAmount' }, width: 120 },
        { title: '可用类目', dataIndex: 'categoryTypeList', scopedSlots: { customRender: 'categoryTypeList' }, width: 350 },
        { title: '可用商品', dataIndex: 'useScopeTypeStr', width: 120 },
        { title: '派券方式', dataIndex: 'distributeWayStr', width: 140 },
        { title: '开始时间', dataIndex: 'receiveStartTimeStr', width: 170 },
        { title: '结束时间', dataIndex: 'receiveEndTimeStr', width: 170 },
        { title: '状态', dataIndex: 'statusStr', width: 100 },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right',
          width: 280
        }
      ]
    }
  },
  methods: {
    getCategoryText (record) {
      return (record.categoryTypeList || []).join('、')
    },
    loadList (requestParams) {
      const { limitDto, couponCode, distributeWay, status } = requestParams
      return this.getHttpServices()
        .getNewServeService()
        .post('/coupon/page', {
          couponCode: couponCode || '',
          distributeWay: distributeWay == null || distributeWay === '' ? null : Number(distributeWay),
          status: status == null || status === '' ? null : Number(status),
          limitDto
        })
    },
    handleCreate () {
      this.$router.push({ name: 'CouponCreate' })
    },
    handleBatchDispatch () {
      this.$router.push({ name: 'CouponBatchDispatch' })
    },
    handleView (record) {
      this.$router.push({
        name: 'CouponDetail',
        query: { couponCode: record.couponCode }
      })
    },
    handleRecord (record) {
      this.$router.push({
        name: 'CouponRecordList',
        query: { couponCode: record.couponCode }
      })
    },
    handleAdvanceStart (record) {
      this.$confirm({
        title: `确定提前开始「${record.couponName}」的领取吗？`,
        onOk: () => this.editCouponStatus(record, 1, '提前开始成功')
      })
    },
    handleAdvanceEnd (record) {
      this.$confirm({
        title: `确定提前结束「${record.couponName}」的领取吗？`,
        onOk: () => this.editCouponStatus(record, 3, '提前结束成功')
      })
    },
    editCouponStatus (record, status, successMsg) {
      return this.getHttpServices()
        .getNewServeService()
        .post('/coupon/editStatus', {
          couponCode: record.couponCode,
          status
        })
        .then(() => {
          this.$message.success(successMsg)
          this.$refs.tableWrap.refresh(false)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试')
        })
    }
  }
}
</script>

<style scoped lang="less">
.coupon-list-page {
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.coupon-list-card {
  height: 100%;
  display: flex;
  flex-direction: column;

  /deep/ .ant-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
}

.ellipsis-cell {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
